import React from 'react';
import Shortcuts from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts/index.tsx';

import { COMMAND_PALETTE_REGISTRY_IDS } from '@atlassian/jira-command-palette-registry/src/common/constants/registry/index.tsx';
import { RegisterCommands } from '@atlassian/jira-command-palette-registry/src/ui/register-commands/index.tsx';
import type { CommandsWithAction } from '../types.tsx';
import { mapCommandsToShortcuts } from '../util.tsx';

export const RegisterForgeCommands = ({ commands }: { commands: Array<CommandsWithAction> }) => {
	if (commands?.length === 0 || !commands) return null;

	const commandsWithShortcut = commands.filter((command) => command.shortcut);

	if (commandsWithShortcut.length === 0) return null;
	/**
	 * As commands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */
	const commandIds = commands.map(({ id }) => id).toString();

	const keyMap = mapCommandsToShortcuts(commandsWithShortcut);

	return (
		<>
			{keyMap && <Shortcuts keyMap={keyMap} />}
			<RegisterCommands
				commands={commands}
				registrationId={COMMAND_PALETTE_REGISTRY_IDS.COPY_URL}
				deps={[commandIds]}
			/>
		</>
	);
};
